export enum StatusVenda {
  PENDING = 1,
  PAID = 2,
  REFUSED = 3,
  CANCELED = 4,
  CHARGEBACK = 5,
  REFUND = 6,
  FAILED = 7,
  TESTE = 8,
  REFUND_COMPLETED = 9,
}

export const STATUS_VENDA_LABEL: Record<StatusVenda, string> = {
  [StatusVenda.PENDING]: 'Pendente',
  [StatusVenda.PAID]: 'Pago',
  [StatusVenda.REFUSED]: 'Recusado',
  [StatusVenda.CANCELED]: 'Cancelado',
  [StatusVenda.CHARGEBACK]: 'Chargeback',
  [StatusVenda.REFUND]: 'Reembolso',
  [StatusVenda.FAILED]: 'Falhou',
  [StatusVenda.TESTE]: 'Teste',
  [StatusVenda.REFUND_COMPLETED]: 'Reembolso completo',
};

export enum MetodoPagamentoVenda {
  PIX = 1,
  BOLETO = 2,
  CARTAO_CREDITO = 3,
  PAYPAL = 4,
  APPLE_PAY = 5,
  GOOGLE_PAY = 6,
  AMAZON_PAY = 7,
}

export enum GatewayVenda {
  CHRONOS = 1,
  STRIPE = 2,
  TOTAL_SALE = 3,
  STARK_BANK = 4,
  MERCADO_PAGO = 5,
  PAYPAL = 6,
}

export enum MoedaVenda {
  BRL = 1,
  USD = 2,
  EUR = 3,
  CLP = 4,
  PEN = 5,
  COP = 6,
  MXN = 7,
  CAD = 8,
  JPY = 9,
  GBP = 10,
  DKK = 11,
  NOK = 12,
  SEK = 13,
  PYG = 14,
}

export interface ClienteVendaCompradorResumo {
  nome: string | null;
  sobrenome: string | null;
  email: string | null;
}

export interface ClienteVendaProdutoResumo {
  id: string | null;
  nome: string | null;
}

export interface ClienteVendaListItem {
  id: string;
  createdAt: string;
  status: StatusVenda | null;
  statusDescricao: string | null;
  moeda: number | null;
  moedaSigla: string | null;
  valor: number | null;
  upsell: boolean;
  comprador: ClienteVendaCompradorResumo;
  produto: ClienteVendaProdutoResumo;
  metodoPagamento: number | null;
  metodoPagamentoDescricao: string | null;
  gateway: number | null;
  gatewayDescricao: string | null;
}

export interface PaginatedClienteVendas {
  data: ClienteVendaListItem[];
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export interface ClienteVendaResumoSecao {
  status: number | null;
  statusDescricao: string | null;
  moeda: number | null;
  moedaSigla: string | null;
  valorPago: number | null;
  metodoPagamento: number | null;
  metodoPagamentoDescricao: string | null;
  gateway: number | null;
  gatewayDescricao: string | null;
  upsell: boolean;
  tipoVenda: 'Upsell' | 'Venda principal';
  vendaParceiroId: string | null;
  transacaoGatewayId: string | null;
  recebiveisOk: boolean;
  reconcileStatus: number | null;
  handledByGlobalChargeback: boolean;
}

export interface ClienteVendaCompradorSecao {
  nome: string | null;
  sobrenome: string | null;
  email: string | null;
  telefone: string | null;
  cpf: string | null;
  endereco: {
    postalCode: string | null;
    state: string | null;
    city: string | null;
    district: string | null;
    address: string | null;
    numero: string | null;
    complement: string | null;
  };
}

export interface ClienteVendaProdutoSecao {
  id: string | null;
  nome: string | null;
  descricao: string | null;
  tipo: number | null;
  tipoDescricao: string | null;
  preco: number | null;
  moeda: number | null;
  moedaSigla: string | null;
  produtor: {
    id: string;
    nome: string;
    sobrenome: string | null;
    email: string;
  } | null;
}

export interface ClienteVendaCheckoutSecao {
  id: string | null;
  status: number | null;
  createdAt: string | null;
  valor: number | null;
  subtotal: number | null;
  total: number | null;
  moeda: number | null;
  moedaSigla: string | null;
  pais: string | null;
  paisEnum: number | null;
  linguagem: string | null;
  ip: string | null;
  metodosPagamento: string | null;
  maximoParcelas: number | null;
  exibirEndereco: boolean;
  exibirCupomDesconto: boolean;
  recorrencia: boolean;
  planoId: string | null;
  plano: Record<string, unknown> | null;
  aplicouCupom: boolean;
  cupom: { id: string; codigo: string | null; desconto: number | null } | null;
  afiliado: {
    id: string;
    nome: string;
    sobrenome: string | null;
    email: string;
  } | null;
  orderBumpsAplicados: Array<Record<string, unknown>>;
  downSells: Array<Record<string, unknown>>;
  valoresParcelas: Record<string, number>;
  backRedirect: string | null;
  paginaObrigado: string | null;
  pixEpirado: string | null;
  pagamentoRecusado: string | null;
}

export interface ClienteVendaRecebivelItem {
  id: string;
  valor: number | null;
  moeda: number | null;
  moedaSigla: string | null;
  status: number | null;
  statusDescricao: string | null;
  tipo: number | null;
  tipoDescricao: string | null;
  origem: number | null;
  releasedIn: string | null;
  createdAt: string;
  sobraSaque: number | null;
  valorAposBloqueio: number | null;
}

export interface ClienteVendaTotaisRecebiveis {
  quantidade: number;
  somaValor: number;
  somaValorAposBloqueio: number;
}

export interface ClienteVendaPagamentoSecao {
  pix: { qrCode: string | null; copiaCola: string | null } | null;
  boleto: {
    linhaDigitavel: string | null;
    codigoBarras: string | null;
    linkExterno: string | null;
  } | null;
  paypal: { approveUrl: string | null } | null;
  stripe: { clientSecret: string | null } | null;
  mercadoPago: { customerId: string | null; cardId: string | null } | null;
  cartao: { cvvCardId: string | null } | null;
  paymentDetails: {
    authorizationCode: string | null;
    last4: string | null;
    providerTransactionId: string | null;
    acquirerReferenceNumber: string | null;
    providerTransactionAt: string | null;
    merchantDescriptor: string | null;
    capturedAt: string | null;
  } | null;
}

export interface ClienteVendaMetadados {
  src: string | null;
  sck: string | null;
  utmSource: string | null;
  utmCampaign: string | null;
  utmMedium: string | null;
  utmContent: string | null;
  utmTerm: string | null;
  urlParams: Record<string, string> | null;
}

export interface ClienteVendaDetail {
  id: string;
  createdAt: string;
  resumo: ClienteVendaResumoSecao;
  comprador: ClienteVendaCompradorSecao;
  produto: ClienteVendaProdutoSecao;
  checkout: ClienteVendaCheckoutSecao | null;
  recebiveis: ClienteVendaRecebivelItem[];
  totaisRecebiveis: ClienteVendaTotaisRecebiveis;
  metadados: ClienteVendaMetadados;
  pagamento: ClienteVendaPagamentoSecao;
  historico: Array<Record<string, unknown>>;
  taxas: Array<Record<string, unknown>>;
  payloadTecnico: Record<string, unknown>;
}

export interface ClienteVendasFilters {
  produtoId?: string;
  produtoNome?: string;
  dataInicio?: string;
  dataFim?: string;
  valorMinimo?: number | '';
  valorMaximo?: number | '';
  moeda?: number | '';
  status?: StatusVenda | '';
  metodoPagamento?: MetodoPagamentoVenda | '';
  gateway?: GatewayVenda | '';
  upsell?: boolean | '';
  compradorNome?: string;
  compradorEmail?: string;
}

export type ClienteVendasFiltersInput = Partial<ClienteVendasFilters>;
